// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  scriptId: __t.u64().primaryKey().name("script_id"),
  projectId: __t.u64().name("project_id"),
  instanceId: __t.u64().name("instance_id"),
  source: __t.string(),
  capsRequested: __t.string().name("caps_requested"),
  capsValid: __t.bool().name("caps_valid"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
